import Dashboard from "../../../common/components/layout/Dashboard";
import Toast from "../../../common/components/ui/toast";
import { ToastProvider } from "../../../common/components/ui/toast/toast.provider";
import TableMaintenanceReports from "./components/table-maintenances/TableMaintenanceReports";

export function MaintenanceReportsRegisterPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableMaintenanceReports />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}
